module.exports = __webpack_public_path__ + "media/images/basic_logos/chart-90f07fe71e7e9d7303a0cd2298e3dd2d.png";